(() => {
  const dialog = document.getElementById('SiltLaunchSignup');
  if (!dialog) return;
  let previousFocus;
  const open = () => {
    if (dialog.open) return;
    previousFocus = document.activeElement;
    dialog.showModal();
    (dialog.querySelector('input[type=email]') || dialog.querySelector('button')).focus();
  };
  dialog.querySelector('[data-silt-launch-close]').addEventListener('click', () => dialog.close());
  let floating = false;
  dialog.addEventListener('close', () => {
    if (floating) { floating = false; return; }
    if (previousFocus?.isConnected) previousFocus.focus();
  });
  // Shopify's hCaptcha challenge is added to <body>, which sits under a modal dialog's top layer.
  // Once the form is valid and sending, drop out of modal mode so the challenge shows on top.
  const launchForm = dialog.querySelector('#SiltLaunchForm');
  launchForm?.addEventListener('submit', () => {
    if (!launchForm.checkValidity() || !dialog.matches(':modal')) return;
    floating = true;
    dialog.close();
    dialog.classList.add('is-floating');
    dialog.show();
  });
  const phone = dialog.querySelector('#SiltLaunchPhone');
  const whatsApp = dialog.querySelector('#SiltLaunchWhatsApp');
  const tags = dialog.querySelector('[data-silt-launch-tags]');
  const note = dialog.querySelector('[data-silt-launch-note]');
  if (phone && whatsApp && tags && note) {
    const baseTags = tags.value;
    // Indian mobile: drop spaces, dashes, +91 / 91 / 0 prefix; 10 digits starting 6-9.
    const digits = () => {
      let d = phone.value.replace(/\D/g, '');
      if (d.length === 12 && d.startsWith('91')) d = d.slice(2);
      else if (d.length === 11 && d.startsWith('0')) d = d.slice(1);
      return d;
    };
    const sync = () => {
      const filled = phone.value.trim() !== '';
      whatsApp.closest('[data-silt-launch-wa]').hidden = !filled;
      whatsApp.required = filled;
      phone.setCustomValidity(!filled || /^[6-9]\d{9}$/.test(digits()) ? '' : phone.dataset.invalid);
      whatsApp.setCustomValidity(filled && !whatsApp.checked ? whatsApp.dataset.required : '');
    };
    phone.addEventListener('input', sync);
    whatsApp.addEventListener('change', sync);
    phone.form.addEventListener('submit', event => {
      sync();
      if (!phone.form.checkValidity()) {
        event.preventDefault();
        phone.form.reportValidity();
        return;
      }
      const number = phone.value.trim() ? `+91${digits()}` : '';
      tags.value = number ? `${baseTags},whatsapp-optin,wa-${number.slice(1)}` : baseTags;
      if (number) {
        note.name = 'contact[note]';
        note.value = `WhatsApp: ${number} (opted in on launch popup)`;
      } else {
        note.removeAttribute('name');
      }
    });
    sync();
  }
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-silt-launch-open]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open();
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.id === 'SiltLaunchForm') return;
    if (/\/cart\/add(?:\.js)?(?:$|[?#])/.test(form.action) || event.submitter?.name === 'checkout') {
      event.preventDefault();
      event.stopImmediatePropagation();
      open();
    }
  }, true);
  const selector = '.silt-buynow__btn,.silt-buybar__cta,button[name="checkout"],input[name="checkout"],a[href*="/checkout"],a[href*="/cart/"]:not([href*="/cart/change"])';
  const template = document.createElement('a');
  template.className = 'silt-launch-button';
  template.href = '#SiltLaunchSignup';
  template.setAttribute('data-silt-launch-open', '');
  template.setAttribute('aria-haspopup', 'dialog');
  template.setAttribute('aria-controls', 'SiltLaunchSignup');
  template.textContent = dialog.dataset.buttonLabel;
  if (template) {
    const replace = () => document.querySelectorAll(selector).forEach(element => {
      if (!element.previousElementSibling?.hasAttribute('data-silt-launch-replacement')) {
        const button = template.cloneNode(true);
        button.setAttribute('data-silt-launch-replacement', '');
        element.before(button);
      }
    });
    replace();
    let pending = false;
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; replace(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (dialog.querySelector('[data-silt-launch-result]') || location.hash === '#SiltLaunchSignup') open();
})();
